<script setup lang="ts">
  import {
    Card,
    CardContent,
    CardFooter,
    CardHeader,
    CardTitle,
  } from "@/components/ui/card"
  import { Skeleton } from "@/components/ui/skeleton"
</script>

<template>
  <Card data-testid="direct-debit-card-skeleton">
    <CardHeader>
      <CardTitle>Your Direct Debit</CardTitle>
    </CardHeader>
    <CardContent>
      <Skeleton class="h-[24px] w-[250px] sm:h-[28px]" />
      <Skeleton class="mt-2 h-[24px] w-[200px] sm:h-[28px]" />
    </CardContent>
    <CardFooter>
      <Skeleton class="h-[36px] w-full sm:w-[195px]" variant="rounded" />
    </CardFooter>
  </Card>
</template>
